import { FilterListingsDto, ListingPublic } from '../types';
import ApiClient from './apiClient';

export const filterListings = async (queryParams: FilterListingsDto): Promise<ListingPublic[]> => {
  return await ApiClient.get<ListingPublic[]>(`auto-i/listings`, { queryParams });
};
